module.exports = __webpack_public_path__ + "media/svg/diversifie-d7ff3b85.svg";